import {
  CloudRecordingsFrequencies,
  CloudRecordingsStatuses,
  CloudRecordingsStorageDuration,
} from "@/components/constants.js"

export default ({ $config = {}, getStatusText }) => {
  return [
    {
      value: "name",
      text: "Name",
      sortable: true,
      width: 160,
    },
    {
      value: "status",
      text: "Status",
      sortable: true,
      width: 160,
      align: "center",
      toStringFn: (item, key) => getStatusText(item[key]),
    },
    {
      value: "exid",
      text: "ID",
      sortable: true,
      width: 90,
      cellClass: "truncate",
    },
    {
      value: "zohoId",
      text: "Zoho",
      sortable: false,
      width: 40,
      align: "center",
      toStringFn: (item, key) =>
        item[key] &&
        `${$config.public.zohoCrmUrl}/tab/CustomModule4/${item[key]}`,
    },
    {
      value: "demo",
      text: "Demo",
      sortable: false,
      width: 40,
      align: "center",
    },
    {
      value: "userFullname",
      text: "Owner",
      sortable: true,
      width: 160,
    },
    {
      value: "userEmail",
      text: "Email",
      width: 160,
      sortable: true,
      visible: false,
      cellClass: "truncate",
    },
    {
      value: "projectName",
      text: "Project",
      sortable: true,
      width: 160,
    },
    {
      value: "createdAt",
      text: "Created At",
      sortable: true,
      width: 135,
    },
    {
      value: "featureFlags",
      text: "Feature Flags",
      sortable: true,
      width: 200,
    },
    {
      value: "powerType",
      text: "Power Type",
      sortable: false,
      width: 100,
    },
    {
      value: "lastOnlineAt",
      text: "Last Online At",
      sortable: true,
      width: 135,
      visible: false,
    },
    {
      value: "cameraHost",
      text: "Camera IP",
      sortable: true,
      width: 165,
    },
    {
      value: "cameraHttpPort",
      text: "Camera Port",
      sortable: true,
      width: 52,
      align: "center",
    },
    {
      value: "nvrHttpPort",
      text: "NVR Port",
      sortable: true,
      width: 52,
      align: "center",
    },
    {
      value: "nvrRtspPort",
      text: "RTSP Port",
      sortable: true,
      width: 52,
      visible: false,
      align: "center",
    },
    {
      value: "deviceId",
      text: "Device ID",
      sortable: true,
      width: 32,
    },
    {
      value: "nvrModel",
      text: "NVR Model",
      sortable: true,
      width: 94,
    },
    {
      value: "cameraUsername",
      text: "Username",
      sortable: true,
      visible: false,
      width: 81,
    },
    {
      value: "cameraPassword",
      text: "Password",
      sortable: true,
      visible: false,
      width: 119,
    },
    {
      value: "recordingFromNvr",
      text: "Recording NVR",
      sortable: true,
      width: 60,
    },
    {
      value: "cameraModel",
      text: "Camera Model",
      sortable: true,
      width: 94,
    },
    {
      value: "timezone",
      text: "Timezone",
      sortable: true,
      width: 136,
    },
    {
      value: "region",
      text: "Region",
      sortable: true,
      width: 70,
      align: "center",
    },
    {
      value: "isPublic",
      text: "Public",
      sortable: true,
      width: 60,
      visible: false,
      align: "center",
    },
    {
      value: "cloudRecordingStorageDuration",
      text: "Duration",
      sortable: true,
      width: 82,
      align: "center",
      toStringFn: (item, key) => parseCloudRecordingStorageDurations(item[key]),
    },
    {
      value: "cloudRecordingStatus",
      text: "CR Status",
      sortable: true,
      width: 79,
      align: "center",
      toStringFn: (item, key) => parseCRStatus(item[key]),
    },
    {
      value: "cloudRecordingFrequency",
      text: "Frequency",
      sortable: true,
      width: 148,
      align: "center",
      toStringFn: (item, key) => parseFrequency(item[key]),
    },
    {
      value: "lastPolledAt",
      text: "Last Polled At",
      sortable: true,
      width: 200,
      visible: false,
    },
    {
      value: "location",
      text: "Location",
      sortable: true,
      width: 309,
      toStringFn: (item, key) =>
        item[key] ? `lat: ${item[key].lat} / lng: ${item[key].lng}` : "-",
    },
  ]
}

export const parseFrequency = (value) => {
  return CloudRecordingsFrequencies.find(
    (frequency) => frequency.value == value
  )?.name
}

export const parseCRStatus = (value) => {
  return CloudRecordingsStatuses.find((status) => status.value === value)?.name
}

export const parseCloudRecordingStorageDurations = (value) => {
  return CloudRecordingsStorageDuration.find((item) => item.value === value)
    ?.name
}
